import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M11 20v-3H7v5h10v-5h-4.4L11 20z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v13h4v-2.5H9L13 7v5.5h2L12.6 17H17V4z"
})), 'BatteryCharging20Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BatteryCharging20Sharp.js
// module id = 2281
// module chunks = 2